import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { seo } from "utils/utils";
import TimePicker from "react-time-picker";
import Breadcrumb from "component/common/breadcrumb";
import { editAppointment, addAppointment } from "../../reduxStore/action/appointmentActions";
import {

  SourcingManager,
  SourcingTL,
  sourcing_head_id,
  SCM,
  SiteHead,
  BusinessHead,
  // AdminRoleId,
  // PostSale,
  // Receptionist,
  ClusterHead,
  admin_id,
 } from "../../utils/constants";
import "./AppointmentListing.css";

const UpdateAppointmentStatus = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form, setForm] = useState({});
  const [formVaild, setFormVaild] = useState({});
  const params = useParams();
  const { _id = "" } = params || {};
  const navigatpage = async (navname) => {
    navigate(navname);
  };

  const {response:res} = useSelector((state) => state.login)
  const updateAppointmentStatusSelector =
    useSelector((state) => state.appointment) || [];

  useEffect(() => {
    if (updateAppointmentStatusSelector.create === true) {
      if (updateAppointmentStatusSelector?.response?.status === 200) {
        setForm({});
        if(res?.data?.role_id === SourcingManager||
          res?.data?.role_id === SourcingTL){
            navigatpage("/appointment_site_visit");
          }else{
            navigatpage("/appointment");
          }
      }
    }
  }, [updateAppointmentStatusSelector]);

  const statusUpdate = () => {
    if (!handleValid()) {
      const fallbackDate = moment().format("YYYY-MM-DD");
      const fallbackTime = "12:00 PM";
      if (Number(form.status) === 1) {
        dispatch(
          addAppointment({
            status: form.status,
            appointment_id: _id,
            appointment_date: form.appointment_date,
            appointment_time: form.appointment_time,
            remark: form.remark,
            update_type: 2,
            type: 1,
          }),
        ).then((result) => {
          if (result?.status === 200) {
            if (
              res?.data?.role_id === SourcingManager ||
              res?.data?.role_id === SourcingTL
            ) {
              navigatpage("/appointment_site_visit");
            } else {
              navigatpage("/appointment");
            }
          }
        });
        return;
      }
      const post = {
        status: form.status,
        appointment_id: _id,
        appointment_date: form.appointment_date || fallbackDate,
        appointment_time: form.appointment_time || fallbackTime,
        remark: form.remark,
      };
      dispatch(editAppointment(post));
    }
  };
  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputTime = (appointment_time) => {
    if (appointment_time) {
      const nextFormState = {
        ...form,
        appointment_time: moment("2000-01-01 " + appointment_time).format(
          "hh:mm A"
        ),
      };
      setForm(nextFormState);
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;

    if (!form.appointment_date && Number(form.status) === 1) {
      formError = true;
      err["appointment_date"] = strings.followup_dateErr;
    }
    if (!form.remark) {
      formError = true;
      err["remark"] = strings.remarkErr;
    }

    if (!form.appointment_time && Number(form.status) === 1) {
      formError = true;
      err["appointment_time"] = strings.followup_timeErr;
    }
    if (!form.status) {
      formError = true;
      err["status"] = strings.statusErr;
    }
    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Status Update",
      metaDescription: "Update appointment status",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.updateStatus}
        url={"/appointment"}
        parentListing={strings.followupList}
        titleactive={strings.updateStatus}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.updateStatus}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.status}
                          <span className="required-field"></span>
                        </label>
                        <select
                          className="form-control digits"
                          id="formcontrol-select1"
                          name="status"
                          value={form.status}
                          onChange={handleInputField}
                        >
                          <option value="">
                            {strings.selectstatus}
                          </option>
                          <option value={1}>{strings.rescheduled}</option>
                          <option value={4}>{strings.appointmentCancel}</option>
                        </select>
                        {formVaild.status && (
                          <span style={{ color: "red" }}>
                            {formVaild.status}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {Number(form.status) === 1 && (
                    <div className="row">
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.date}
                            <span className="required-field"></span>
                          </label>
                          <input
                            className="form-control datetimepicker-input digits"
                            type="date"
                            name="appointment_date"
                            value={form.appointment_date}
                            onChange={handleInputField}
                            min={moment().format("yyyy-MM-DD")}
                          />
                          {formVaild.appointment_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.appointment_date}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.time}
                            <span className="required-field"></span>
                          </label>
                          <TimePicker
                            onChange={handleInputTime}
                            value={form.appointment_time}
                            type="time"
                            clockIcon={null}
                            clearIcon={null}
                            disableClock={true}
                            format={"hh:mm a"}
                            className="form-control"
                            name="appointment_time"
                          />
                          {formVaild.appointment_time && (
                            <span style={{ color: "red" }}>
                              {formVaild.appointment_time}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.description}
                          <span className="required-field"></span>
                        </label>
                        <textarea
                          className="form-control"
                          name="remark"
                          value={form.remark}
                          onChange={handleInputField}
                          id=""
                          cols="74"
                          rows="5"
                        ></textarea>
                        {formVaild.remark && (
                          <span style={{ color: "red" }}>
                            {formVaild.remark}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end">
                      <div className="card-footer">
                        <button
                          className="justo-appointment__btn justo-appointment__btn--solid"
                          type="button"
                          onClick={statusUpdate}
                        >
                          {strings.update}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UpdateAppointmentStatus;
